<template>
  <div class="h-9 bg-n-50 dark:bg-n-900 rounded flex cursor-pointer relative overflow-hidden">
    <div
      v-for="(option, index) in options"
      :key="option.value.toString()"
      class="h-full flex items-center rounded px-4 z-10 transition flex-1 justify-center overflow-hidden gap-1"
      :class="{
        'text-n-800 dark:text-n-0': model === option.value,
        'text-n-600 opacity-30 dark:text-n-0': model !== option.value
      }"
      @click="select(index)"
    >
      <l-icon v-if="option.icon" :name="option.icon" :original-color="option.iconOriginalColor" />
      <div v-if="option.label" class="truncate text-center text-sm">
        {{ option.label }}
      </div>
    </div>
    <div
      v-if="options.length > 0"
      class="absolute h-full top-0 left-0 transition-all will-change-transform"
      :style="selectionStyle"
    >
      <div class="bg-n-0 dark:bg-n-700 h-full border border-n-50 dark:border-n-900 rounded"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { LIconName } from './icon.type'
import LIcon from './LIcon.vue'

export type OptionValue = string | boolean

export interface Option {
  label?: string
  value: OptionValue
  icon?: LIconName
  iconOriginalColor?: boolean
}

interface Props {
  options: Option[]
}

const model = defineModel<OptionValue>()

const props = withDefaults(defineProps<Props>(), {
  options: () => []
})

function select(index: number) {
  model.value = props.options[index].value
}

const selectionStyle = computed(() => {
  const count = props.options.length || 1
  const selectedIndex = Math.max(
    props.options.findIndex(option => option.value === model.value),
    0
  )
  // Highlight width = 100% / count, move by index * 100% using transform.
  return {
    width: `calc(100% / ${count})`,
    transform: `translateX(${selectedIndex * 100}%)`
  }
})
</script>
